/* eslint-disable react/require-default-props */
/**
 * This component is proposed to handle images loaded from an URL.
 * The default behaviour is to show an spinner GIF while the image
 * is loading. In case of errors on loading image, a error .svg takes
 * place in the component.
 *
 * In the future, performance enhancements could be done by pre-caching
 * the image like Jack described in following article:
 * https://jack72828383883.medium.com/how-to-preload-images-into-cache-in-react-js-ff1642708240
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaPen } from 'react-icons/fa';

import './styles.css';

import loadingImg from '../../../support/assets/images/loading.gif';
import blankImg from '../../../support/assets/images/blank.svg';

export default function Image({
  src = '', alt = '', rounded = false, spinner = true, edit = false, editAction = () => {}, circledColor = false, bottomShadow = false,
}) {
  const [imageUrl, setImageUrl] = useState(spinner ? loadingImg : src || blankImg);

  const handleImageErrored = () => {
    setImageUrl(blankImg);
  };

  const updateImage = () => {
    setImageUrl(() => {
      if (src !== '' && src !== null) return src;
      if (src === null || src === '') return blankImg;
      return loadingImg;
    });
  };

  useEffect(() => {
    updateImage();
  }, [src]);

  return (
    <div style={{display:'flex', flexDirection:'column'}}>
      <div
        className="imageContainer"
        style={circledColor ? {
          borderWidth: 2,
          borderRadius: '50%',
          borderColor: circledColor,
          borderStyle: 'solid',
          padding: 5,
          backgroundColor:'#fff',
        } : {}}
      >
        <img
          src={imageUrl}
          onError={handleImageErrored}
          alt={alt}
          className={rounded ? 'rounded' : ''}
        />
        {edit

      && (
        <button className={rounded ? 'edit rounded' : 'edit'}>
          <FaPen onClick={editAction} className="touchableIcon" size={18} color="#fff" />
        </button>
      )}
      </div>
      {bottomShadow
      && (
        <div style={{
          backgroundColor: 'rgb(112,112,112,0.2)',
          width: '50%',
          height: 6,
          borderRadius: '50%',
          marginTop:4,
          alignSelf:'center'
        }}
        />
      )}
    </div>
  );
}

Image.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  rounded: PropTypes.bool,
  spinner: PropTypes.bool,
  edit: PropTypes.bool,
  editAction: PropTypes.func,
  circledColor: PropTypes.string,
};
